import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";

@Injectable()
export class LessonGroupService {
  private readonly apiPrefix = '/admin/lesson-groups'

  constructor(
    private api: ApiService,
  ) {
  }

  getGroups(qs = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}${qs}`);
  }

  createGroup(data): Observable<any> {
    return this.api.post(`${this.apiPrefix}`, data);
  }

  updateGroup(id: number, data): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  deleteGroup(id: number): Observable<any> {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }
}
